<template>
    <button class="iconic-action-button" :class="$slots.icon ? 'has-icon' : ''">
        <span class="floating-bg" :style="`background: ${color}`"></span>
        <span class="hover-bg"></span>
        <span class="label">
            <span v-if="$slots.icon" class="icon"><slot name="icon"/></span>
            <span class="text"><slot/></span>
        </span>
    </button>
</template>

<script>
export default {
    name: "IconicActionButton",
    props: {
        color: {
            type: String,
            default: '#000',
        }
    }
}
</script>

<style lang="scss" scoped>
.iconic-action-button{
    border: none;
    border-radius: .3rem;
    background: none;
    position: relative;
    overflow: hidden;
    padding: 0;
    color: white;

    &.has-icon{
        .hover-bg{
            width: 2rem;
        }
    }

    &:hover{
        .hover-bg{
            width: 100%;
        }
    }
}

.floating-bg{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.hover-bg{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 0;
    transition: width .3s;
    background: rgba(black, .15);
}

.icon{
    width: 2rem;
    flex: 0 0 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.label{
    position: relative;
    z-index: 2;
    display: flex;
    align-items: stretch;
}

.text{
    padding: 0.4rem 0.8rem 0.4rem 0.6rem;
    font-weight: $font-weight-bold;
    text-transform: uppercase;
}
</style>
